export const NAME = 'members';

export const ADD_MEMBER_FORM = 'addMemberForm';
export const UPDATE_MEMBER_FORM = 'updateMemberForm';
export const MEMBER_IMAGE_FORM = 'memberImageForm';